export default __webpack_public_path__ + "static/media/ideaImage.28af58f5.png";